import React, { useState } from "react";
import {
  Box,
  Heading,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Button,
  useToast,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import emailjs from "emailjs-com";

const Contact = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const toast = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const templateParams = {
      from_email: email,
      message: message,
    };

    try {
      await emailjs.send(
        "service_vmhaqqw", // Substitua pelo seu Service ID
        "template_ltxyr3s", // Substitua pelo seu Template ID
        templateParams,
        "DyAJLKDUMpsFJ-M-T" // Substitua pelo seu User ID
      );
      toast({
        title: "Mensagem enviada.",
        description: "Sua mensagem foi enviada com sucesso.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      setEmail("");
      setMessage("");
    } catch (error) {
      toast({
        title: "Erro ao enviar.",
        description: "Ocorreu um erro ao enviar sua mensagem.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <Box textAlign="center" py={10} px={6}>
        <Heading as="h2" size="xl" mb={4}>
          Contato
        </Heading>
        <form onSubmit={handleSubmit}>
          <FormControl id="email" mb={4}>
            <FormLabel>Email</FormLabel>
            <Input
              type="email"
              placeholder="Seu email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </FormControl>
          <FormControl id="message" mb={4}>
            <FormLabel>Mensagem</FormLabel>
            <Textarea
              placeholder="Sua mensagem"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            />
          </FormControl>
          <Button type="submit" colorScheme="teal" size="lg">
            Enviar
          </Button>
        </form>
      </Box>
    </motion.div>
  );
};

export default Contact;
